import { Checkbox } from '@/components/DesignLibrary/Atoms';

type Props = {
  allowUnknownValues: boolean;
  onChange: (newValue: boolean) => void;
};

const AllowUnknownValues: React.FC<Props> = ({ allowUnknownValues, onChange }) => (
  <Checkbox
    label="Allow 'Unknown' as a value"
    isChecked={allowUnknownValues}
    onChange={onChange}
    size="sm"
  />
);

export default AllowUnknownValues;